import { StagesStoreActionsClass } from './StagesStoreActionsClass';

const StagesStore: StagesStoreActionsClass = new StagesStoreActionsClass();

export { StagesStore };
